var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { isSelectKey } from '../../../common/keyCodes';
import { st, classes } from './Tab.st.css';
import { TABS_DATA_KEYS } from '../dataHooks';
import { Component } from '../GenericComponent';
export var Tab = React.forwardRef(function (props, ref) {
    var _a;
    var index = props.index, item = props.item, onClick = props.onClick, isActive = props.isActive, indicateActive = props.indicateActive, className = props.className, isTabDiv = props.isTabDiv;
    var tabType = 'Link';
    if (isTabDiv) {
        tabType = 'Div';
    }
    else if (item.href) {
        tabType = 'Anchor';
    }
    var title = item.title, href = item.href, target = item.target, rel = item.rel, prefix = item.prefix;
    var onSelectTab = function () {
        onClick(index);
    };
    var onKeyDown = function (e) {
        if (isSelectKey(e)) {
            onSelectTab();
            e.preventDefault();
            return false;
        }
    };
    var dataAttributes = (_a = {},
        _a[TABS_DATA_KEYS.tabIndex] = index,
        _a[TABS_DATA_KEYS.tabIsActive] = isActive,
        _a);
    var renderTitle = function () {
        var Title = function () { return (React.createElement("div", { className: classes.tabContentWrapper },
            prefix ? React.createElement("span", { className: classes.prefix }, prefix) : null,
            React.createElement("span", null, title))); };
        switch (tabType) {
            case 'Anchor':
                return (React.createElement("a", { className: "has-custom-focus", href: href, target: target, rel: rel },
                    React.createElement(Title, null)));
            case 'Link':
                return (React.createElement("span", { role: "link" },
                    React.createElement(Title, null)));
            case 'Div':
            default:
                return React.createElement(Title, null);
        }
    };
    return (React.createElement(Component, __assign({ ref: ref, className: st(classes.root, { isActive: isActive, indicateActive: indicateActive, hasAnchor: tabType === 'Anchor' }, className, 'has-custom-focus') }, dataAttributes, { "data-hook": props['data-hook'], key: "".concat(title, "-").concat(index), id: item.id, onClick: onSelectTab, onKeyDown: onKeyDown, tabIndex: tabType === 'Link' ? 0 : -1 }, (tabType !== 'Div' && {
        'aria-current': isActive,
        renderAs: 'li',
    }), (tabType === 'Div' && __assign({ role: 'tab', renderAs: 'div' }, (isActive && {
        'aria-current': true,
        'aria-controls': "".concat(item.id, "-tab"),
    })))), renderTitle()));
});
//# sourceMappingURL=Tab.js.map